import { render, staticRenderFns } from "./LiveReportedCommentModal.vue?vue&type=template&id=4bca0eb9&scoped=true&"
import script from "./LiveReportedCommentModal.vue?vue&type=script&lang=js&"
export * from "./LiveReportedCommentModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bca0eb9",
  null
  
)

export default component.exports